import { PlusOutlined } from "@ant-design/icons";
import { Button, message, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import { useHasEditPermission } from "../../common/hooks";
import DynamicTable from "../../components/DynamicTable";
import StationModal from "./components/StationModal";

function Stations() {
  const [editingKey, setEditingKey] = useState(null);
  const [stations, setStations] = useState({});
  const [showStationModal, setShowStationModal] = useState(false);
  const allowEdit = useHasEditPermission();

  useEffect(() => {
    fetchStations();
  }, []);

  const fetchStations = async () => {
    const res = await apiRequest({
      path: apiPaths.stations,
    });
    if (!res.error) {
      let itemsObj = res.results.reduce((items, item) => {
        items[item._id] = item;
        return items;
      }, {});
      setStations(itemsObj);
    } else {
      message.error(res.error_description);
    }
  };

  const COLUMNS = [
    {
      title: "S/N",
      dataIndex: "station_number",
      fixed: "left",
      width: 80,
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "220px",
      render: (_, record) => {
        return record.name;
      },
      filterType: "search",
    },
    {
      title: "Address",
      dataIndex: "address",
      width: "220px",
      render: (_, record) => {
        return Object.values(record.address || {}).join(", ");
      },
    },
    {
      title: "Coordinates",
      dataIndex: "coordinates",
      width: "220px",
      render: (_, record) => {
        return record.location.coordinates.join(", ");
      },
    },
    {
      title: "Created By",
      dataIndex: "coordinates",
      width: "150px",
      render: (_, record) => {
        return (
          <div>
            <div>{record.created_by?.fullname}</div>
            <div style={{ color: "#a7a7a7", fontSize: 11 }}>
              {moment(record.created_at).fromNow()}
            </div>
          </div>
        );
      },
    },
    {
      title: "Updated By",
      dataIndex: "coordinates",
      width: "150px",
      render: (_, record) => {
        return (
          <div>
            <div>
              {record.updated_by
                ? record.updated_by?.fullname
                : record.created_by?.fullname}
            </div>
            <div style={{ color: "#a7a7a7", fontSize: 11 }}>
              {moment(record.updated_at).fromNow()}
            </div>
          </div>
        );
      },
    },
  ];

  const handleRowCanceled = () => {
    setShowStationModal(false);
  };

  const handleRowEdit = (idx) => {
    setEditingKey(idx);
    setShowStationModal(true);
  };

  const handleRowSave = async (row) => {
    if (editingKey == null) {
      const res = await apiRequest({
        path: apiPaths.stations,
        method: "POST",
        data: row,
      });
      if (res.error) {
        message.error(res.error_description);
        return;
      }
      stations[res._id] = res;
      setStations(stations);
      setShowStationModal(false);
      return;
    }
    let key = editingKey;
    const res = await apiRequest({
      path: apiPaths.stations + `/${key}`,
      method: "PUT",
      data: row,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    stations[editingKey] = res;
    setStations({ ...stations });
    setEditingKey(null);
    setShowStationModal(false);
  };

  return (
    <div style={{ height: "80vh" }}>
      {allowEdit ? (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginRight: 10,
          }}
        >
          <Tooltip title="Add Station">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setEditingKey(null);
                setShowStationModal(true);
              }}
            />
          </Tooltip>
        </div>
      ) : null}
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(stations)}
          columns={COLUMNS}
          scroll={{
            // x: 2250,
            y: "65vh",
          }}
          requireEdit={allowEdit}
          editHandler={(record) => handleRowEdit(record._id)}
          pagination={false}
        />
      </div>
      {showStationModal ? (
        <StationModal
          open={showStationModal}
          onSave={handleRowSave}
          onCancel={handleRowCanceled}
          data={stations[editingKey]}
          isUpdate={true}
        />
      ) : null}
    </div>
  );
}

export default Stations;
